import { render } from "./Settings.vue?vue&type=template&id=cf0f65a2"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__